import React from 'react';
import { Modal } from '../../components/ui';

const findField = (fields, key) => fields.find(field => field.key === key) || { key, label: key };
const optionsOf = (list) => (list || []).map(o => (
  <option key={o.value ?? o} value={o.value ?? o}>{o.label ?? o}</option>
));

// Desktop event form (Super Admin): a 640px dialog, every box only as wide as
// what goes in it - name | type, then who runs the event (segmented Existing /
// New user) and the user's details on one line. Enter saves.
export default function EventFormDesktop({ vm }) {
  const { open, editing, values, fields, saving, setField, save, closeForm } = vm;
  if (!open) return null;

  const adminMode = values.EventAdminMode || 'Existing User';
  const eventName = findField(fields, 'EventName');
  const eventType = findField(fields, 'EventTypeId');
  const adminModeField = findField(fields, 'EventAdminMode');
  const existingAdmin = findField(fields, 'EventAdminUserId');
  const newAdminName = findField(fields, 'EventAdminName');
  const newAdminMobile = findField(fields, 'EventAdminMobileNumber');
  const newAdminPassword = findField(fields, 'EventAdminPassword');
  const onEnter = (e) => { if (e.key === 'Enter') { e.preventDefault(); save(); } };
  const modes = adminModeField.options && adminModeField.options.length ? adminModeField.options : ['Existing User', 'New User'];

  return (
    <Modal
      className="ev-event-modal"
      title={`${editing ? 'Edit' : 'Add'} Event`}
      onClose={closeForm}
      footer={<>
        <span className="ev-summary">
          {values.EventName ? <strong>{values.EventName}</strong> : 'Name, type and who runs the event'}
        </span>
        <button className="btn light" onClick={closeForm}>Cancel</button>
        <button className="btn primary" disabled={saving} onClick={save}>{saving ? 'Saving...' : 'Save'}</button>
      </>}
    >
      <div className="ev-row ev-event-r1">
        <label className="field">Event Name *
          <input autoFocus value={values.EventName ?? ''} placeholder="e.g. Sahil weds Diksha"
            onChange={(e) => setField(eventName, e.target.value)} onKeyDown={onEnter} />
        </label>
        <label className="field">Event Type *
          <select value={values.EventTypeId ?? ''} onChange={(e) => setField(eventType, e.target.value)}>
            <option value="">- select -</option>
            {optionsOf(eventType.options)}
          </select>
        </label>
      </div>

      <div className="ev-row ev-event-r2">
        <div className="field ev-admin-label">Event Admin *
          <div className="ev-seg" role="group" aria-label="Event Admin">
            {modes.map(m => {
              const v = m.value ?? m;
              return (
                <button key={v} type="button" className={adminMode === v ? 'on' : ''}
                  onClick={() => setField(adminModeField, v)}>{m.label ?? m}</button>
              );
            })}
          </div>
        </div>
        {adminMode === 'Existing User' ? (
          <label className="field">Existing User *
            <select value={values.EventAdminUserId ?? ''} onChange={(e) => setField(existingAdmin, e.target.value)}>
              <option value="">- select -</option>
              {optionsOf(existingAdmin.options)}
            </select>
          </label>
        ) : <span />}
      </div>

      {adminMode !== 'Existing User' && (
        <div className="ev-row ev-event-r3">
          <label className="field">New User Name *
            <input value={values.EventAdminName ?? ''} placeholder="Full name"
              onChange={(e) => setField(newAdminName, e.target.value)} onKeyDown={onEnter} />
          </label>
          <label className="field">Mobile *
            <input type="tel" inputMode="numeric" value={values.EventAdminMobileNumber ?? ''} placeholder="10 digits"
              onChange={(e) => setField(newAdminMobile, e.target.value)} onKeyDown={onEnter} />
          </label>
          <label className="field">Password
            <input value={values.EventAdminPassword || '1234'}
              onChange={(e) => setField(newAdminPassword, e.target.value)} onKeyDown={onEnter} />
          </label>
        </div>
      )}
    </Modal>
  );
}
